/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import {
  Notification
} from "element-ui";

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };

export default new Router({
  mode: "history",
  // base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "on",
  routes: [
    /** 总首页 */
    {
      path: "/",
      name: "index_",
      redirect: "/allIndex",
    },
    /** 总首页 */
    {
      path: "/allIndex",
      name: "allIndex",
      component: () => import("@/views/allIndex"),
      meta: {
        withoutFoot: false,
      },
    },
    /** VR/AR */
    {
      // vr
      path: "/vr",
      name: "vr",
      component: () => import("@/views/VR_AR/vr"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      // ar
      path: "/ar",
      name: "ar",
      component: () => import("@/views/VR_AR/ar"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      // 线上选型
      path: "/vrselect",
      name: "vrselect",
      component: () => import("@/views/VR_AR/vrselect"),
      meta: {
        withoutFoot: false,
      },
    },
    /** 云上展 */
    {
      path: "/yun",
      name: "yun",
      redirect: "/index",
      component: () =>
        import( /* webpackChunkName: "calculation" */ "@/views/index"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //首页
      path: "/index",
      name: "index",
      component: () => import("@/views/index"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //数字展厅
      path: "/exhibition",
      name: "exhibition",
      component: () => import("@/views/exhibition"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //3D动画
      path: "/threeD",
      name: "threeD",
      component: () => import("@/views/threeD"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //小程序开发
      path: "/applet",
      name: "applet",
      component: () => import("@/views/applet"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //APP开发
      path: "/app",
      name: "app",
      component: () => import("@/views/app"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //MG动画
      path: "/mg",
      name: "mg",
      component: () => import("@/views/mg"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //海外推广
      path: "/overseas",
      name: "overseas",
      component: () => import("@/views/overseas"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //短视频运营
      path: "/video",
      name: "video",
      component: () => import("@/views/video"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //弃用的bi数据可视化
      path: "/bi",
      name: "bi",
      component: () => import("@/views/bi"),
      meta: {
        withoutFoot: false,
      },
    },
    /** 数智邦*/
    {
      path: "/fate",
      name: "fate",
      redirect: "/digitIndex",
      component: () => import("@/views/digitIndex"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //首页
      path: "/digitIndex",
      name: "digitIndex",
      component: () => import("@/views/digitIndex"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //BI数据可视化
      path: "/bidata",
      name: "bidata",
      component: () => import("@/views/bidata"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //QMS
      path: "/qms",
      name: "qms",
      component: () => import("@/views/qms"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //设备管理
      path: "/device",
      name: "device",
      component: () => import("@/views/device"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //工业VR/AR
      path: "/var",
      name: "var",
      component: () => import("@/views/var"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //3D可视化
      path: "/visua",
      name: "visua",
      component: () => import("@/views/visua"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //远程运维
      path: "/remote",
      name: "remote",
      component: () => import("@/views/remote"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //MES
      path: "/mes",
      name: "mes",
      component: () => import("@/views/mes"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //ERP
      path: "/erp",
      name: "erp",
      component: () => import("@/views/erp"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //APS
      path: "/aps",
      name: "aps",
      component: () => import("@/views/aps"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      // WMS
      path: "/wms",
      name: "wms",
      component: () => import("@/views/wms"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //数据采集
      path: "/acquisition",
      name: "acquisition",
      component: () => import("@/views/acquisition"),
      meta: {
        withoutFoot: false,
      },
    },
    /** 资讯专区*/
    {
      //首页
      path: "/news",
      name: "news",
      component: () => import("@/views/news"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //资讯列表
      path: "/inforlist",
      name: "inforlist",
      component: () => import("@/views/inforlist"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //资讯详情
      path: "/listDetail",
      name: "listDetail",
      component: () =>
        import( /* webpackChunkName: "calculation" */ "@/views/listDetail"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //案例列表
      path: "/cases",
      name: "cases",
      component: () => import("@/views/cases"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //案例详情
      path: "/inside",
      name: "inside",
      component: () => import("@/views/inside"),
      meta: {
        withoutFoot: false,
      },
    },

    /** 视频专区*/
    {
      //视频列表
      path: "/videoList",
      name: "videoList",
      component: () => import("@/views/videoList"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //视频详情
      path: "/videoDetail",
      name: "videoDetail",
      component: () => import("@/views/videoDetail"),
      meta: {
        withoutFoot: false,
      },
    },
    /** 关于我们*/
    {
      path: "/about",
      name: "about",
      component: () => import( /* webpackChunkName: "about" */ "@/views/about"),
      meta: {
        withoutFoot: false,
      },
    },
    {
      //弃用的表单
      path: "/calculation",
      name: "calculation",
      component: () => import("@/views/calculation"),
      meta: {
        withoutFoot: true,
      },
    },
    {
      path: "*",
      name: "NOT FOUND",
      component: () => import("@/views/notfound/index"),
    },
  ],
});
